import React from 'react';
import cx from 'classnames';

const DEFAULT_PRGRESS_TITLE = 'Progress tracker';

const formatProgressPercentage = (percent?: number) =>
  `${percent || 0}% completed`;

type Props = {
  title?: string;
  percent: number;
  className?: string;
};

export default function BaseProgressPercentage(props: Props) {
  const { title = DEFAULT_PRGRESS_TITLE, percent, className = '' } = props;

  return (
    <div className={cx('title-line', className)}>
      <div className="title-line__text">{title}</div>
      <span className="title-line__line" />

      <div className="title-line__subtext">
        {formatProgressPercentage(percent)}
      </div>
    </div>
  );
}
